import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";

interface IPostContractProps {
  data: any;
}

export async function PostContract({ data }: IPostContractProps) {
  const url = `${endpoints.ADMFHIR}/Contract`;

  const headers = {
    Accept: "*/*",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };

  const response = await useAxios.post(url, data, { headers, timeout: 20000 })
    .then((response: any) => {
      if (
        response.status !== HTTPResponseStatus.Success &&
        response.status !== HTTPResponseStatus.Created
      ) {
        throw new Error(`PostContract: ${response.status}`);
      }
      return response.data;
    })
    .catch((error: any) => {
      console.error("PostContract ", error);
      // toast.error(`PostContract Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
